var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, ElementRef } from '@angular/core';
import { FileUpload } from "../../shared/app/classes/file-upload";
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Validation } from '../../shared/app/services/validation';
import { PayeeApi, StorageApi, PayeeServiceApi, PayeeCardsEcommerceApi } from '../../shared/sdk/services';
import { GlobalEventsManager } from '../../events-manager.component';
import { SubmissionDetailService } from "../../shared/app/services/";
import { LoopBackConfig } from "../../shared/sdk/lb.config";
var ɵ0 = window;
var CardsUatLiveComponent = /** @class */ (function (_super) {
    __extends(CardsUatLiveComponent, _super);
    function CardsUatLiveComponent(payeeApi, payeeCardsEcommerceApi, payeeServiceApi, router, storageApi, eventManager, validation, submissionDetailService, sanitizer, document) {
        var _this = _super.call(this, payeeApi, storageApi, eventManager) || this;
        _this.payeeApi = payeeApi;
        _this.payeeCardsEcommerceApi = payeeCardsEcommerceApi;
        _this.payeeServiceApi = payeeServiceApi;
        _this.router = router;
        _this.storageApi = storageApi;
        _this.eventManager = eventManager;
        _this.validation = validation;
        _this.submissionDetailService = submissionDetailService;
        _this.sanitizer = sanitizer;
        _this.document = document;
        _this.TAG = "CardsUatLiveComponent";
        _this.new = false;
        _this.valid = true;
        _this.uatSignOff = null;
        _this.uatMerchantDeclarationSignOff = null;
        _this.disabledGoLiveDate = false;
        _this.uatCompleted = false;
        _this.checklistStatuses = ["Web Checklist Completed", "Merchant to review", "Pending Website Checklist Approval"];
        return _this;
    }
    // Initialisation
    CardsUatLiveComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var date, minGoLiveDateObject;
            var _this = this;
            return __generator(this, function (_a) {
                this.scrollToTop();
                date = new Date();
                minGoLiveDateObject = this.addDays(new Date(), 5);
                this.todayDate = {
                    year: date.getFullYear(),
                    month: date.getMonth() + 1,
                    day: date.getDate()
                };
                this.minGoLiveDate = {
                    year: minGoLiveDateObject.getFullYear(),
                    month: minGoLiveDateObject.getMonth() + 1,
                    day: minGoLiveDateObject.getDate()
                };
                this.myDatePickerOptions = {
                    // other options...
                    dateFormat: 'dd.mm.yyyy',
                    editableDateField: false,
                    openSelectorOnInputClick: true,
                    disableUntil: this.todayDate
                };
                this.randomFileName = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15) + ".pdf";
                if (window.screen.width < 1200) { // 768px portrait
                    this.isMobile = true;
                }
                this.getFileDetails('uat_cards_ecom_signoff').subscribe(function (res) {
                    if (res) {
                        console.log(_this.TAG + " getFileDetails('uat_cards_ecom_signoff')");
                        console.log(res);
                        if (res.length > 0) {
                            _this.uatSignOff = res[0].file_name;
                        }
                    }
                });
                this.getFileDetails('uat_cards_merchant_declaration_signoff').subscribe(function (res) {
                    if (res) {
                        console.log(_this.TAG + " getFileDetails('uat_cards_merchant_declaration_signoff')");
                        console.log(res);
                        if (res.length > 0) {
                            _this.uatMerchantDeclarationSignOff = res[0].file_name;
                        }
                    }
                });
                this.getEcomTechData().subscribe(function (res) {
                    console.log(_this.TAG + "getEcomTechData: ");
                    console.log(res);
                    _this.eventsManager.loaded(true);
                    _this.mids = res[0].MIDs;
                    _this.mids.amex_12m_prod_hashkey;
                    _this.cardsEcom = res[0].cardEcom;
                    _this.submissionTags = res[0].submission.submission_tags;
                    _this.submissionId = res[0].submission.id;
                    if (_this.cardsEcom.go_live_date != null) {
                        _this.liveDateObject = new Date(_this.cardsEcom.go_live_date);
                        _this.minGoLiveDate.year = _this.liveDateObject.getFullYear();
                        _this.minGoLiveDate.month = _this.liveDateObject.getMonth() + 1;
                        _this.minGoLiveDate.day = _this.liveDateObject.getDate();
                        _this.dateModel = {
                            date: _this.minGoLiveDate
                        };
                        _this.disabledGoLiveDate = true;
                    }
                    if (_this.submissionTags) {
                        //If uat completed status is in
                        if (_this.submissionTags.filter((function (submission_tags) { return submission_tags.tag_id == 22; })).length > 0) {
                            _this.uatCompleted = true;
                        }
                    }
                }, function (err) {
                    _this.eventsManager.loaded(true);
                    console.log(err);
                    _this.router.navigate(['/dashboard']);
                });
                return [2 /*return*/];
            });
        });
    };
    CardsUatLiveComponent.prototype.getEcomTechData = function () {
        var filter = {
            where: {
                'submission_id': this.submissionDetailService.getCurrentSubmissionId()
            },
            include: [
                "MIDs",
                "cardEcom",
                {
                    "relation": "submission",
                    "scope": {
                        "include": "submission_tags"
                    }
                }
            ],
            limit: 1
        };
        return this.payeeApi.getServices(this.payeeApi.getCurrentId(), filter);
    };
    CardsUatLiveComponent.prototype.addDays = function (date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    };
    CardsUatLiveComponent.prototype.updateGoLiveDate = function () {
        return this.payeeCardsEcommerceApi.updateGoLiveDate(this.cardsEcom.payee_service_id, this.dateModel.jsdate.toString());
    };
    CardsUatLiveComponent.prototype.innerHtml = function () {
        return this.sanitizer.bypassSecurityTrustHtml("<object data='" + LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/" + this.payeeApi.getCurrentId() + "/download/" + this.file_name + "?access_token=" + this.payeeApi.getCurrentToken().id + "' type='application/pdf' class='embed-responsive-item'>" +
            "<embed src='" + LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() + "/storages/" + this.payeeApi.getCurrentId() + "/download/" + this.file_name + "?access_token=" + this.payeeApi.getCurrentToken().id + "' type='application/pdf' />" +
            "</object>");
    };
    CardsUatLiveComponent.prototype.addEventListeners = function () { };
    CardsUatLiveComponent.prototype.submit = function (submit) {
        var _this = this;
        // Send to temp storage
        var promises = [];
        var that = this;
        this.valid = this.validate();
        if (this.valid) {
            console.log(this.TAG + ":submit");
            this.updateGoLiveDate().subscribe(function (res) {
                console.log(res);
                _this.eventsManager.showPopUp("UAT sign off sheet and expected Go-Live date have been submitted.");
                _this.router.navigate(['/dashboard']);
            }, function (err) {
                console.log(err);
                _this.eventsManager.showPopUp("Unable to submit. Please try again later");
            });
        }
    };
    CardsUatLiveComponent.prototype.downloadMDF = function () {
        this.mdfDownload.nativeElement.click();
    };
    CardsUatLiveComponent.prototype.downloadCG = function () {
        this.cardGuideDownload.nativeElement.click();
    };
    CardsUatLiveComponent.prototype.downloadUSO = function () {
        this.uatsoDownload.nativeElement.click();
    };
    CardsUatLiveComponent.prototype.modifyDate = function (date) {
        return date.charAt(3) + date.charAt(4) + '-' + date.charAt(0) + date.charAt(1) + date.substring(5);
    };
    CardsUatLiveComponent.prototype.addDoc = function (name, event, zip, submissionId) {
        _super.prototype.addDoc.call(this, name, event, zip, submissionId);
    };
    CardsUatLiveComponent.prototype.deleteDoc = function (name) {
        _super.prototype.deleteDoc.call(this, name);
    };
    CardsUatLiveComponent.prototype.updateDocStatus = function (name, fileName) {
        switch (name) {
            case 'uat_cards_ecom_signoff':
                this.uatSignOff = fileName;
                break;
            case 'uat_cards_merchant_declaration_signoff':
                this.uatMerchantDeclarationSignOff = fileName;
                break;
        }
    };
    ;
    CardsUatLiveComponent.prototype.validateDocs = function () {
        this.docsValid = this.uatSignOff;
        this.docsValid = this.uatMerchantDeclarationSignOff;
        return this.docsValid;
    };
    ;
    CardsUatLiveComponent.prototype.validate = function () {
        this.valid = true;
        this.docsValid = true;
        this.valid = this.dateModel;
        // this.valid = this.uatSignOff;
        this.valid = this.validateDocs() && this.valid;
        this.valid = this.doneUat && this.valid;
        return this.valid;
    };
    // Scrolling
    CardsUatLiveComponent.prototype.scrollToTop = function () {
        window.scroll(0, 0);
        document.body.getElementsByClassName('scroll_cards_uat_live')[0].scrollTop = 0;
    };
    CardsUatLiveComponent.prototype.scrollToSave = function () {
        document.body.getElementsByClassName('scroll_cards_uat_live')[0].scrollTop = document.getElementById('save_cards_uat_live').offsetTop;
    };
    return CardsUatLiveComponent;
}(FileUpload));
export { CardsUatLiveComponent };
export { ɵ0 };
